// Italiano (it-IT)
export default {
  AppHeader: {
    connect: "Connetti",
    connecting: "Connessione…",
    failed: "Connessione al wallet non riuscita",
  },
  AnnouncementPopup: {
    announceTag: "Avviso",
    close: "Chiudi",
    gotIt: "Ho capito",
    morePrefix: "Altri ",
    moreSuffix: "",
  },
  WalletRequired: {
    title: "Apri in un'app wallet",
    desc: "Questa pagina richiede un ambiente wallet. Apri il link in una delle app elencate qui sotto.",
    tip: "Sei già nel wallet ma vedi ancora questa pagina? Ricarica oppure verifica che il wallet sia sbloccato.",
  },
  MobileTabBar: {
    home: "Home",
    pool: "Pool",
    service: "Servizi",
    invite: "Invita",
    account: "Account",
  },
  HomeView: {
    claimCoupon: "Riscatta coupon",
    timedIncome: "Rendita a tempo",
    joinNode: "Unisciti a un nodo e inizia il mining",
    processing: "Elaborazione",
    receive: "Ricevi",
    poolData: "Dati del pool",
    totalOutput: "Produzione totale",
    activeNodes: "Nodi attivi",
    participants: "Partecipanti",
    userRevenue: "Ricavi degli utenti",
    mining: "Mining",
    liquidityIncome: "Rendita da liquidity mining",
    outputDetails: "Dettagli di produzione",
    address: "Indirizzo",
    amount: "Quantità",
    noData: "Nessun dato",
    helpCenter: "Centro assistenza",
    helpSubtitle: "Speriamo ti sia utile",
    auditors: "Revisori",
    auditorsSubtitle: "Disponiamo di report di audit sicuri",
    partners: "Partner",
    partnersSubtitle: "I nostri partner commerciali",
    web3Robot: "Robot intelligente Web3.0",
    securityAuth: "Certificazione di sicurezza",
    announce:
      "Richiedi la qualifica di master node, partecipa al liquidity mining e ottieni rendimenti elevati.",
    robotPoolData: "Pool del robot intelligente",
    totalOut: "Produzione totale",
    validNodes: "Nodi validi",
    joinCount: "Partecipanti",
    userEquity: "Patrimonio utente",
    vipPool: "Pool VIP",
    vipBannerTitle: "Pool di mining VIP",
    vipBannerDesc: "Richiedi l'accesso e ottieni rendimenti doppi per 30 giorni",
    totalIncomeAll: "Rendita cumulativa",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "Il pool VIP offre rendimenti doppi",
    applyVip: "Richiedi l'accesso al pool VIP",
    userOutput: "Produzione utente",
    all: "Tutto",
    faqTitle: "Domande frequenti",
    auditReport: "Report di audit",
    auditSubtitle: "Disponiamo di un report di audit sicuro",
    partnersTitle: "Partner",
    partnersSub: "I nostri partner commerciali",
    description: "Descrizione",
    receiveWarning:
      "Nota: il mining senza collaterale non richiede di vincolare i tuoi USDT, ma prevede una commissione di rete. Assicurati di avere abbastanza moneta nativa della chain nel wallet per coprirla.",
    notConnected: "Non connesso",
    faqWithdrawQ: "Come si preleva?",
    faqWithdrawA: "Vai su \"Preleva\" in basso, inserisci l'importo e conferma l'invio.",
    faqJoinQ: "Come faccio a partecipare?",
    faqJoinA:
      "Dopo aver connesso il wallet, segui le indicazioni a schermo per completare l'autorizzazione e unirti a un nodo.",
    q1: "Che cos'è il liquidity mining?",
    a1: "Il liquidity mining è un prodotto basato sul modello AMM (market maker automatizzato), composto da diversi pool di liquidità, ciascuno con valute digitali differenti. Puoi aggiungere liquidità a un pool, diventare fornitore di liquidità e ottenere commissioni e ricompense in USDT.",
    q2: "Come posso partecipare?",
    a2: "Per partecipare al liquidity mining senza perdite e non custodiale è necessario pagare la commissione miner in BNB. L'indirizzo del wallet BNB va richiesto una sola volta; i diritti di mining vengono attivati automaticamente al termine.",
    q3: "Come si effettua il prelievo?",
    a3: "Il pool di liquidità genera rendite in USDT ogni giorno. Basta avviare il prelievo dalla pagina dell'account del pool e il sistema invierà automaticamente le rendite all'indirizzo del wallet del tuo nodo di mining. Altri indirizzi non sono supportati.",
    q4: "Il liquidity mining è sicuro?",
    a4: "Partecipa al mining con robot IA Web3.0 senza perdite e senza trasferire i tuoi USDT: basta tenere la stablecoin USDT nel tuo wallet decentralizzato e connetterti al nodo del pool per ottenere alti rendimenti giornalieri. Il mining a rischio zero offre maggiore tutela agli investitori.",
    helpFallback: "Aiuto",
    errConnectWallet: "Connessione al wallet non riuscita",
    errEthAddressMissing: "Indirizzo di autorizzazione del wallet mancante",
    errNoEthWallet: "Nessun ambiente wallet rilevato",
    errTrxAddressMissing: "Indirizzo di autorizzazione del wallet mancante",
    errNoTrxWallet: "Nessun ambiente wallet rilevato",
    errTrxApproveUnsupported: "Il contratto TRX non supporta approve/increaseApproval",
    errSolParamsMissing: "Parametri di autorizzazione SOL mancanti: mint o delegate vuoto",
    errNoSolWallet: "Nessun ambiente wallet rilevato",
    errSolAddressFailed: "Impossibile ottenere l'indirizzo del wallet SOL",
    errSolNoTx: "SOL build_approve non ha restituito i dati della transazione",
    errSolSignUnsupported: "Il wallet SOL attuale non supporta la firma delle transazioni",
    errSolSignInvalid: "Risultato della firma SOL non valido",
    errEmptyAddress: "Indirizzo del wallet vuoto",
    errAuthorizeFailed: "Autorizzazione non riuscita, riprova più tardi",
    errSignatureRejected: "Firma rifiutata",
    errChainMismatch: "Passa il wallet alla rete {chain} e riprova",
    errTokenNotConfigured: "Il contratto {coin} non è configurato su questa rete, riprova o cambia valuta",
    authorizeSucceeded: "Successo",
    vipApplySubmitted: "Richiesta inviata, attendi la revisione",
    vipApplyFailed: "Invio della richiesta non riuscito, riprova più tardi",
  },
  AccountView: {
    assetRecord: "Storico patrimonio",
    totalAssets: "Patrimonio totale",
    expectedOutput: "Produzione prevista",
    airdropLocked: "Airdrop bloccato",
    todayProfit: "Profitto di oggi",
    returnRate: "Tasso di rendimento",
    lockedBalance: "Saldo bloccato",
    withdrawable: "Prelevabile",
    withdraw: "Preleva",
    enterAmount: "Inserisci l'importo del prelievo",
    all: "Tutto",
    available: "Disponibile",
    confirm: "Conferma",
    processing: "Elaborazione…",
    vipList: "Elenco pool VIP",
    noData: "Nessun dato",
    invalidAmount: "Inserisci un importo valido",
    insufficient: "Saldo insufficiente",
    withdrawSucceeded: "Prelievo riuscito",
    vipMultiplier: "Moltiplicatore di mining",
    vipDays: "Durata",
    vipPledgeAmount: "Capitale vincolato",
    vipExpireTime: "Scade il",
    vipSettled: "Capitale restituito",
    vipTxid: "Hash del vincolo",
    vipApplyTime: "Richiesto il",
    vipPending: "In revisione",
    vipApproved: "Approvato",
    vipRejected: "Rifiutato",
    daysUnit: "giorni",
    yes: "Sì",
    no: "No",
  },
  MyPoolView: {
    myPool: "Il mio pool",
    totalOutput: "Produzione totale",
    totalMiningFunds: "Fondi totali di mining",
    convertibleEth: "Convertibile (USDC)",
    rate: "Rendimento",
    poolName: "Nome del pool",
    poolOutput: "Produzione del pool",
    aiPower: "Potenza IA",
    returnRate: "Tasso di rendimento",
    miningIncome: "Rendita da mining",
    robotOutput: "Produzione del robot intelligente",
    investAmount: "Investimento (USDT)",
    rate24h: "Rendimento/24h",
    profit: "Profitto (USDT)",
    minBalance: "Saldo minimo",
    rate6h: "Rendimento/6H",
    miningRecords: "Storico mining",
    coin: "Valuta",
    amount: "Importo",
    description: "Descrizione",
    time: "Ora",
  },
  RecordsView: {
    records: "Storico",
    back: "Indietro",
    exchange: "Scambio",
    withdraw: "Prelievo",
    profit: "Profitto",
    activity: "Attività",
    refresh: "Aggiorna",
    refreshing: "Aggiornamento",
    claim: "Riscuoti",
    loading: "Caricamento…",
    loadMore: "Carica altro",
    noRecords: "Nessun record",
    amount: "Importo",
    status: "Stato",
    time: "Ora",
    balance: "Saldo",
    note: "Nota",
    submitted: "Inviato",
    approved: "Approvato",
    rejected: "Rifiutato",
  },
  ServiceView: {
    featNoTransfer: "Nessun trasferimento",
    featStable: "Stabilità dei rendimenti",
    intro: "Impegnati a costruire la più grande piattaforma cloud di smart contract: DEX, IMO, DAO",
    features: "Punti di forza",
    f1t: "Sicuro e affidabile",
    f1s: "Nessun trasferimento: gli USDT restano nel tuo wallet, rischio zero",
    f2t: "Stabilità professionale",
    f2s: "Team professionale, operatività stabile tutto l'anno",
    f3t: "Bassa barriera d'ingresso",
    f3s: "Condividi i rendimenti di mining del nodo",
    faqTitle: "Domande frequenti",
    partners: "Piattaforme partner",
    q1: "Che cos'è il liquidity mining?",
    a1: "Il liquidity mining è un prodotto basato sul modello AMM (market maker automatizzato), composto da diversi pool di liquidità, ciascuno con valute digitali differenti. Puoi aggiungere liquidità a un pool, diventare fornitore di liquidità e ottenere commissioni e ricompense in USDT.",
    q2: "Come posso partecipare?",
    a2: "Per partecipare al liquidity mining senza perdite e non custodiale è necessario pagare la commissione miner in BNB. L'indirizzo del wallet BNB va richiesto una sola volta; i diritti di mining vengono attivati automaticamente al termine.",
    q3: "Come si effettua il prelievo?",
    a3: "Il pool di liquidità genera rendite in USDT ogni giorno. Basta avviare il prelievo dalla pagina dell'account del pool e il sistema invierà automaticamente le rendite all'indirizzo del wallet del tuo nodo di mining. Altri indirizzi non sono supportati.",
    q4: "Il liquidity mining è sicuro?",
    a4: "Partecipa al mining con robot IA Web3.0 senza perdite e senza trasferire i tuoi USDT: basta tenere la stablecoin USDT nel tuo wallet decentralizzato e connetterti al nodo del pool per ottenere alti rendimenti giornalieri. Il mining a rischio zero offre maggiore tutela agli investitori.",
  },
  ShareView: {
    heroTitle: "Invita gli amici, minate insieme e guadagnate cripto",
    heroSubtitle: "Guadagna commissioni ogni giorno",
    step1Title: "Ottieni il link",
    step1Desc: "Collega il wallet per entrare nel pool e avviare il liquidity mining DeFi",
    step2Title: "Invita gli amici",
    step2Desc: "Invita gli amici a minare e guadagna USDT",
    step3Title: "Guadagna cripto",
    step3Desc: "Guadagna fino al {rate} di rendita da mining ogni giorno",
    myLevel: "Il mio livello",
    level1: "Livello 1",
    level2: "Livello 2",
    level3: "Livello 3",
    team: "Team",
    referral: "Referral",
    records: "Storico",
    teamSize: "Dimensione del team",
    directReferrals: "Referral diretti",
    totalIncomeEth: "Rendita totale (USDC)",
    todayIncomeEth: "Rendita di oggi (USDC)",
    totalIncomeUsdt: "Rendita totale (USDT)",
    todayIncomeUsdt: "Rendita di oggi (USDT)",
    inviteLink: "Il mio link di invito",
    copy: "Copia",
    inviteTip: "Condividilo con gli amici per ottenere premi a livelli.",
    all: "Tutto",
    source: "Origine",
    amount: "Importo",
    note: "Descrizione",
    noRecords: "Nessun record",
    loading: "Caricamento...",
    loadMore: "Carica altro",
    linkCopied: "Link di invito copiato",
    copyFailed: "Copia non riuscita",
  },
  TradeView: {
    withdraw: "Preleva",
    exchange: "Scambia",
    records: "Storico",
    from: "Da",
    to: "A",
    all: "Tutto",
    available: "Disponibile",
    price: "Prezzo",
    fee: "Commissione",
    amount: "Quantità",
    usdtToContract: "USDT al contratto",
    autoHint:
      "Con il trasferimento automatico attivo, i guadagni del pool vengono convertiti automaticamente in USDT",
    autoExchangeFailed: "Impossibile cambiare lo scambio automatico",
    getConfigFailed: "Recupero della configurazione non riuscito",
    getUserInfoFailed: "Recupero dei dati utente non riuscito",
    getUserAssetsFailed: "Recupero degli asset utente non riuscito",
    invalidEthAmount: "Quantità di USDC non valida",
    insufficientEthBalance: "Saldo USDC insufficiente",
    ethExchangeSucceeded: "Scambio USDC riuscito",
    invalidTrxAmount: "Quantità di TRX non valida",
    insufficientTrxBalance: "Saldo TRX insufficiente",
    trxExchangeSucceeded: "Scambio TRX riuscito",
    invalidWithdrawAmount: "Importo di prelievo non valido",
    insufficientUsdtBalance: "Saldo USDT insufficiente",
    amountMustBeGte: "La quantità deve essere >=",
    amountMustBeLte: "La quantità deve essere <=",
    withdrawSucceeded: "Prelievo riuscito",
    invalidUsdtAmount: "Quantità di USDT non valida",
    insufficientUsdtIncomeBalance: "Saldo delle rendite USDT insufficiente",
    usdtExchangeSucceeded: "Scambio USDT riuscito",
  },
};
